export const enUSContext = function (){
    const temp = {};
    const files = require.context('@/locales/lang', true, /^\.\/(\w*\/)+en-US\.js$/);
    files.keys().forEach(file => {
        let module = files(file).default;
        Object.assign(temp, module);
    });
    console.log(temp);
    return temp;
};

export const zhCNContext = function (){
    const temp = {};
    const files = require.context('@/locales/lang', true, /^\.\/(\w*\/)+zh-CN\.js$/);
    files.keys().forEach(file => {
        let module = files(file).default;
        Object.assign(temp, module);
    });
    return temp;
};
